export default __webpack_public_path__ + "static/on-track-mobile-f919899b88cc2955fb1be61fe226e36c.svg";